var _desc, _defs, _rect, _rect2, _rect3, _g, _text, _g2, _circle, _g3, _circle2, _circle3, _g4, _circle4, _circle5, _g5, _circle6, _circle7, _circle8, _g6, _circle9, _g7, _circle10, _polyline, _polyline2, _polyline3, _polyline4, _polyline5, _g8, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAwsArchitecture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 420",
    width: 1080,
    height: 420,
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "AWS Cloud \u2014 Event-Driven Pipeline Architecture") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "IoT Core Greengrass \u2192 Kinesis Streams \u2192 EKS Isolated Pods \u2192 EventBridge \u2192 Aurora Storage and SNS Alerts. Polyline connections.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "softShadow",
    x: "-10%",
    y: "-10%",
    width: "120%",
    height: "120%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 4,
    stdDeviation: 10,
    floodColor: "#0f172a",
    floodOpacity: 0.08
  })), /*#__PURE__*/React.createElement("marker", {
    id: "arrowLight",
    viewBox: "0 0 10 10",
    refX: 9,
    refY: 5,
    markerWidth: 7,
    markerHeight: 7,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 10 5 L 0 10 z",
    fill: "#334155"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1080,
    height: 420,
    rx: 20,
    fill: "#ffffff",
    stroke: "#e2e8f0",
    strokeWidth: 1.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 1048,
    height: 388,
    rx: 18,
    fill: "#f8fafc",
    stroke: "#cbd5e1",
    strokeWidth: 1.6,
    strokeDasharray: "10 7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 1048,
    height: 388,
    rx: 18,
    fill: "none",
    stroke: "#94a3b8",
    strokeWidth: 0.6,
    strokeDasharray: "3 6",
    opacity: 0.35
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(30,28)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 126,
    height: 24,
    rx: 12,
    fill: "#ffffff",
    stroke: "#e2e8f0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 7,
    width: 10,
    height: 10,
    rx: 2,
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 16.5,
    fontFamily: "JetBrains Mono, monospace",
    fontSize: 10.5,
    fontWeight: 700,
    letterSpacing: "0.06em",
    fill: "#0f172a"
  }, "AWS Cloud"))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 1048,
    y: 40,
    textAnchor: "end",
    fontFamily: "JetBrains Mono, monospace",
    fontSize: 9,
    fill: "#94a3b8",
    letterSpacing: "0.05em"
  }, "architecture-beta")), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#softShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 68,
    width: 162,
    height: 108,
    rx: 14,
    fill: "#ffffff",
    stroke: "#e2e8f0",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 68,
    width: 162,
    height: 26,
    rx: 14,
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 80,
    width: 162,
    height: 14,
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("text", {
    x: 117,
    y: 85,
    textAnchor: "middle",
    fontFamily: "JetBrains Mono, monospace",
    fontSize: 8.5,
    fontWeight: 600,
    letterSpacing: "0.10em",
    fill: "#64748b"
  }, "SERVER"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(89,102)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 26,
    height: 26,
    rx: 7,
    fill: "#FFF7ED",
    stroke: "#FF9900",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    y: 18,
    textAnchor: "middle",
    fontSize: 13,
    fill: "#FF9900"
  }, "\u25C9")), /*#__PURE__*/React.createElement("text", {
    x: 117,
    y: 146,
    textAnchor: "middle",
    fontFamily: "Inter, sans-serif",
    fontSize: 11.5,
    fontWeight: 650,
    fill: "#0f172a"
  }, "IoT Core"), /*#__PURE__*/React.createElement("text", {
    x: 117,
    y: 160,
    textAnchor: "middle",
    fontFamily: "Inter, sans-serif",
    fontSize: 11,
    fontWeight: 400,
    fill: "#475569"
  }, "Greengrass"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 198,
    cy: 122,
    r: 3,
    fill: "#334155",
    stroke: "#ffffff",
    strokeWidth: 1.1
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#softShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 68,
    width: 162,
    height: 108,
    rx: 14,
    fill: "#ffffff",
    stroke: "#e2e8f0",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 68,
    width: 162,
    height: 26,
    rx: 14,
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 80,
    width: 162,
    height: 14,
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("text", {
    x: 317,
    y: 85,
    textAnchor: "middle",
    fontFamily: "JetBrains Mono, monospace",
    fontSize: 8.5,
    fontWeight: 600,
    letterSpacing: "0.10em",
    fill: "#64748b"
  }, "SERVER"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(289,102)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 26,
    height: 26,
    rx: 7,
    fill: "#FFF7ED",
    stroke: "#FF9900",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    y: 18,
    textAnchor: "middle",
    fontSize: 13,
    fill: "#FF9900"
  }, "\u224B")), /*#__PURE__*/React.createElement("text", {
    x: 317,
    y: 146,
    textAnchor: "middle",
    fontFamily: "Inter, sans-serif",
    fontSize: 11.5,
    fontWeight: 650,
    fill: "#0f172a"
  }, "Kinesis"), /*#__PURE__*/React.createElement("text", {
    x: 317,
    y: 160,
    textAnchor: "middle",
    fontFamily: "Inter, sans-serif",
    fontSize: 11,
    fontWeight: 400,
    fill: "#475569"
  }, "Streams"))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 236,
    cy: 122,
    r: 3,
    fill: "#94a3b8",
    stroke: "#ffffff",
    strokeWidth: 1.1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 398,
    cy: 122,
    r: 3,
    fill: "#334155",
    stroke: "#ffffff",
    strokeWidth: 1.1
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#softShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 436,
    y: 68,
    width: 162,
    height: 108,
    rx: 14,
    fill: "#ffffff",
    stroke: "#e2e8f0",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436,
    y: 68,
    width: 162,
    height: 26,
    rx: 14,
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436,
    y: 80,
    width: 162,
    height: 14,
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("text", {
    x: 517,
    y: 85,
    textAnchor: "middle",
    fontFamily: "JetBrains Mono, monospace",
    fontSize: 8.5,
    fontWeight: 600,
    letterSpacing: "0.10em",
    fill: "#64748b"
  }, "SERVER"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(489,102)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 26,
    height: 26,
    rx: 7,
    fill: "#FFF7ED",
    stroke: "#FF9900",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    y: 18,
    textAnchor: "middle",
    fontSize: 13,
    fill: "#FF9900"
  }, "\u2B22")), /*#__PURE__*/React.createElement("text", {
    x: 517,
    y: 146,
    textAnchor: "middle",
    fontFamily: "Inter, sans-serif",
    fontSize: 11.5,
    fontWeight: 650,
    fill: "#0f172a"
  }, "EKS Isolated"), /*#__PURE__*/React.createElement("text", {
    x: 517,
    y: 160,
    textAnchor: "middle",
    fontFamily: "Inter, sans-serif",
    fontSize: 11,
    fontWeight: 400,
    fill: "#475569"
  }, "Pods"))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 436,
    cy: 122,
    r: 3,
    fill: "#94a3b8",
    stroke: "#ffffff",
    strokeWidth: 1.1
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 598,
    cy: 122,
    r: 3,
    fill: "#334155",
    stroke: "#ffffff",
    strokeWidth: 1.1
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#softShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 636,
    y: 68,
    width: 162,
    height: 108,
    rx: 14,
    fill: "#ffffff",
    stroke: "#0f172a",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 636,
    y: 68,
    width: 162,
    height: 26,
    rx: 14,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 636,
    y: 80,
    width: 162,
    height: 14,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("text", {
    x: 717,
    y: 85,
    textAnchor: "middle",
    fontFamily: "JetBrains Mono, monospace",
    fontSize: 8.5,
    fontWeight: 700,
    letterSpacing: "0.09em",
    fill: "#ffffff"
  }, "HUB \u2022 SERVER"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(689,102)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 26,
    height: 26,
    rx: 7,
    fill: "#FF9900",
    stroke: "#FF9900",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    y: 18,
    textAnchor: "middle",
    fontSize: 13,
    fill: "#ffffff"
  }, "\u2B21")), /*#__PURE__*/React.createElement("text", {
    x: 717,
    y: 146,
    textAnchor: "middle",
    fontFamily: "Inter, sans-serif",
    fontSize: 11.5,
    fontWeight: 700,
    fill: "#0f172a"
  }, "EventBridge"), /*#__PURE__*/React.createElement("text", {
    x: 717,
    y: 160,
    textAnchor: "middle",
    fontFamily: "JetBrains Mono, monospace",
    fontSize: 8.5,
    fill: "#64748b"
  }, "event bus"))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 636,
    cy: 122,
    r: 3,
    fill: "#94a3b8",
    stroke: "#ffffff",
    strokeWidth: 1.1
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 798,
    cy: 122,
    r: 3,
    fill: "#334155",
    stroke: "#ffffff",
    strokeWidth: 1.1
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 717,
    cy: 176,
    r: 3,
    fill: "#334155",
    stroke: "#ffffff",
    strokeWidth: 1.1
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#softShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 862,
    y: 68,
    width: 162,
    height: 108,
    rx: 14,
    fill: "#ffffff",
    stroke: "#e2e8f0",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 862,
    y: 68,
    width: 162,
    height: 26,
    rx: 14,
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 862,
    y: 80,
    width: 162,
    height: 14,
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("text", {
    x: 943,
    y: 85,
    textAnchor: "middle",
    fontFamily: "JetBrains Mono, monospace",
    fontSize: 8.5,
    fontWeight: 600,
    letterSpacing: "0.10em",
    fill: "#64748b"
  }, "SERVER"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(915,102)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 26,
    height: 26,
    rx: 7,
    fill: "#FFF7ED",
    stroke: "#FF9900",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    y: 18,
    textAnchor: "middle",
    fontSize: 12,
    fill: "#FF9900"
  }, "\u2709")), /*#__PURE__*/React.createElement("text", {
    x: 943,
    y: 146,
    textAnchor: "middle",
    fontFamily: "Inter, sans-serif",
    fontSize: 11.5,
    fontWeight: 650,
    fill: "#0f172a"
  }, "SNS"), /*#__PURE__*/React.createElement("text", {
    x: 943,
    y: 160,
    textAnchor: "middle",
    fontFamily: "Inter, sans-serif",
    fontSize: 11,
    fontWeight: 400,
    fill: "#475569"
  }, "Alerts"))), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 862,
    cy: 122,
    r: 3,
    fill: "#94a3b8",
    stroke: "#ffffff",
    strokeWidth: 1.1
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#softShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 636,
    y: 248,
    width: 162,
    height: 108,
    rx: 14,
    fill: "#ffffff",
    stroke: "#e2e8f0",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 636,
    y: 248,
    width: 162,
    height: 26,
    rx: 14,
    fill: "#EFF6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 636,
    y: 260,
    width: 162,
    height: 14,
    fill: "#EFF6FF"
  }), /*#__PURE__*/React.createElement("text", {
    x: 717,
    y: 265,
    textAnchor: "middle",
    fontFamily: "JetBrains Mono, monospace",
    fontSize: 8.5,
    fontWeight: 600,
    letterSpacing: "0.10em",
    fill: "#2563eb"
  }, "DATABASE"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(689,282)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 26,
    height: 26,
    rx: 7,
    fill: "#EFF6FF",
    stroke: "#2563eb",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    y: 18,
    textAnchor: "middle",
    fontSize: 13,
    fill: "#2563eb"
  }, "\u25A6")), /*#__PURE__*/React.createElement("text", {
    x: 717,
    y: 326,
    textAnchor: "middle",
    fontFamily: "Inter, sans-serif",
    fontSize: 11.5,
    fontWeight: 650,
    fill: "#0f172a"
  }, "Aurora"), /*#__PURE__*/React.createElement("text", {
    x: 717,
    y: 340,
    textAnchor: "middle",
    fontFamily: "Inter, sans-serif",
    fontSize: 11,
    fontWeight: 400,
    fill: "#475569"
  }, "Storage"))), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 717,
    cy: 248,
    r: 3,
    fill: "#94a3b8",
    stroke: "#ffffff",
    strokeWidth: 1.1
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "198,122 217,122 236,122",
    fill: "none",
    stroke: "#334155",
    strokeWidth: 1.9,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    markerEnd: "url(#arrowLight)",
    opacity: 0.95
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "398,122 417,122 436,122",
    fill: "none",
    stroke: "#334155",
    strokeWidth: 1.9,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    markerEnd: "url(#arrowLight)",
    opacity: 0.95
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    points: "598,122 617,122 636,122",
    fill: "none",
    stroke: "#334155",
    strokeWidth: 1.9,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    markerEnd: "url(#arrowLight)",
    opacity: 0.95
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    points: "798,122 830,122 862,122",
    fill: "none",
    stroke: "#334155",
    strokeWidth: 1.9,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    markerEnd: "url(#arrowLight)",
    opacity: 0.95
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    points: "717,176 717,212 717,248",
    fill: "none",
    stroke: "#334155",
    strokeWidth: 1.9,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    markerEnd: "url(#arrowLight)",
    opacity: 0.95
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fontFamily: "JetBrains Mono, monospace",
    fontSize: 7.5,
    fill: "#94a3b8",
    letterSpacing: "0.03em"
  }, /*#__PURE__*/React.createElement("text", {
    x: 217,
    y: 113,
    textAnchor: "middle"
  }, "R \u2192 L"), /*#__PURE__*/React.createElement("text", {
    x: 417,
    y: 113,
    textAnchor: "middle"
  }, "R \u2192 L"), /*#__PURE__*/React.createElement("text", {
    x: 617,
    y: 113,
    textAnchor: "middle"
  }, "R \u2192 L"), /*#__PURE__*/React.createElement("text", {
    x: 830,
    y: 113,
    textAnchor: "middle"
  }, "R \u2192 L"), /*#__PURE__*/React.createElement("text", {
    x: 730,
    y: 216,
    textAnchor: "middle"
  }, "B \u2192 T"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 1042,
    y: 392,
    textAnchor: "end",
    fontFamily: "JetBrains Mono, monospace",
    fontSize: 7.5,
    fill: "#94a3b8"
  }, "polyline \u2022 AWS icons \u2022 light theme")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwsArchitecture);
export default __webpack_public_path__ + "static/media/aws-architecture.d2a1abc192737c43b30c2fc78d66000d.svg";
export { ForwardRef as ReactComponent };